import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { SchedulerControls } from 'components/common/bryntumScheduler/SchedulerControlsHook';

import { Button } from 'components/DesignSystem/Button';
import { UseViewsManagerProvider } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager.provider';
import { useViewConfigurationLogic } from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/ViewConfiguration.logic';
import classes from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/ViewConfiguration.module.scss';
import { ViewConfigurationDrawerForm } from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/components/ViewConfigurationDrawerForm/ViewConfigurationDrawerForm';
import { ViewControlsBar } from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/components/ViewControlsBar/ViewControlsBar';

interface Props {
    api: UseViewsManagerProvider['api'];
    isConfigureDrawerOpen: boolean;
    setIsConfigureDrawerOpen: (open: boolean) => void;
    update: (patch: Partial<SchedulerControls>) => void;
    isPresentationMode: boolean;
    onTogglePresentationMode: () => void;
}

export const ViewConfiguration = ({
    api,
    isConfigureDrawerOpen,
    setIsConfigureDrawerOpen,
    update,
    isPresentationMode,
    onTogglePresentationMode,
}: Props) => {
    const { logic } = useViewConfigurationLogic({ api, update });

    return (
        <div className={classes.PoapView}>
            <ViewConfigurationDrawerForm
                api={api}
                isOpen={isConfigureDrawerOpen}
                onClose={() => setIsConfigureDrawerOpen(false)}
                viewId={logic.viewId}
                isViewOwner={logic.isViewOwner}
            />
            <div className={classes.wrapper}>
                <div className={classes.headerConfig}>
                    <div className={classes.viewName}>{logic.viewName}</div>
                    <div className={classes.headerActions}>
                        <Button
                            variant={'tertiary'}
                            onClick={onTogglePresentationMode}
                            startIcon={<MuiIcon icon={'crop_free'} color={'inherit'} />}
                        >
                            {isPresentationMode ? 'Exit presentation mode' : 'Presentation mode'}
                        </Button>
                        {!isPresentationMode && (
                            <Button
                                variant={'tertiary'}
                                onClick={() => setIsConfigureDrawerOpen(true)}
                                startIcon={<MuiIcon icon={'tune'} color={'inherit'} />}
                            >
                                Configure view
                            </Button>
                        )}
                        <Button
                            variant={'tertiary'}
                            onClick={() => logic.setShowControls((open) => !open)}
                            startIcon={
                                <MuiIcon
                                    icon={logic.showControls ? 'aspect_ratio' : 'filter_alt'}
                                    color={'inherit'}
                                    type={'outlined'}
                                />
                            }
                        >
                            {logic.showControls ? 'Hide controls' : 'Show controls'}
                        </Button>
                    </div>
                </div>
                {logic.showControls && (
                    <ViewControlsBar
                        api={api}
                        colorBy={logic.colorBy}
                        showBaseline={logic.showBaseline}
                        showLabels={logic.showLabels}
                        setShowBaseline={logic.setShowBaseline}
                        setShowLabels={logic.setShowLabels}
                        setColorBy={logic.setColorBy}
                        update={update}
                    />
                )}
            </div>
        </div>
    );
};
